import { ModelResource } from './resource';
import { Attachment, EmailSender } from '../models';
import type { EmailSenderProvider } from '../models';
import type { AxiosResponse } from 'axios';

export class EmailSenders extends ModelResource<EmailSender> {
  model = EmailSender;

  resourcePath = 'v1/email-senders';

  async getAuthorizationUrl(
    redirectUri: string,
    provider?: EmailSenderProvider | null,
    scopes?: string[] | null,
  ): Promise<{ url: string }> {
    return this.api
      .get(this.path('nylas', 'authorization-url'), {
        params: {
          redirect_uri: redirectUri,
          ...(provider ? { provider } : {}),
          ...(scopes?.length ? { scopes } : {}),
        },
      })
      .then(
        (
          res: AxiosResponse<{
            url: string;
          }>,
        ) => {
          return { url: res.data.url };
        },
      );
  }

  async reconnectGrant(
    emailSenderId: string,
    authorizationCode: string | undefined,
    redirectUri: string,
  ): Promise<EmailSender> {
    return this.api
      .post(this.path(emailSenderId, 'reconnect-grant'), {
        data: {
          authorization_code: authorizationCode,
          redirect_uri: redirectUri,
        },
      })
      .then((res) => {
        return EmailSender.fromJson(res.data);
      });
  }

  async updateSignature(
    emailSender: EmailSender,
    body: string | null,
    attachments?: Attachment[],
  ): Promise<EmailSender> {
    return this.api
      .post(this.path(emailSender.id, 'signature'), {
        data: {
          body: body,
          attachments: attachments?.map((attachment: Attachment) => attachment.id),
        },
      })
      .then((res) => {
        emailSender.updateFromJson(res.data);
        return emailSender;
      });
  }
}
